import { CONSTANT } from '../../../constant/constant';
import { ENDPOINTS } from '../../../constant/endpoints';
import {
    generalHttpGetRequest
} from '../../../helper/request-helper';

const fetchRolesUrl = CONSTANT.baseUrl + ENDPOINTS.employee.role.fetchRoles;

export const actionType = {
    REQUESTED_ROLE_DATA: 'REQUESTED_ROLE_DATA',
    REJECTED_ROLE_DATA: 'REJECTED_ROLE_DATA',
    FETCH_ROLES: 'FETCH_ROLES'
};

export const fetchRoles = () => {
    return dispatch => {
        dispatch({
            type: actionType.REQUESTED_ROLE_DATA
        });

        return generalHttpGetRequest(fetchRolesUrl)
            .then(response => {
                dispatch({
                    type: actionType.FETCH_ROLES,
                    payload: response.data
                });
                return response;
            })
            .catch(error => {
                dispatch({
                    type: actionType.REJECTED_ROLE_DATA,
                    data: error
                });
                return error;
            });
    };
};




// WEBPACK FOOTER //
// ./src/services/redux/employee/role/actions.js